import { useState, useEffect } from 'react';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { SCUIContent } from '../../atomic/organisms';
import { useTranslation } from 'react-i18next';
import { OrderCommand, PaymentCommand } from '../../services/command';
import { CargoQuery, OrderQuery } from '../../services/query';
import Helper from '../../utils/helper';
import TimeHelper from '../../../src/utils/time';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { SCUIButton, SCUILoadingLinear, SCUINoRecordComponent } from '../../atomic/atoms';
import { SCUICustomDataGrid, SCUIGeneralDrawer, SCUIBreadCrumb } from '../../atomic/molecules';
import { SCUIOrderDetailDrawerContent, SCUIOrderFilter } from './components';
import {
    IconButton,
    Menu,
    MenuItem,
    Grid,
    Typography,
    Button,
    Tooltip,
    Link,
    Card,
    CardContent,
    Box,
    Stack,
    Chip,
} from '@mui/material';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import SearchIcon from '@mui/icons-material/Search';
import DeleteIcon from '@mui/icons-material/Delete';
import HistoryIcon from '@mui/icons-material/History';
import { getRequests, initialState, OrderDetailFilter } from './Order.helper';
import airdropShipment from '../../assets/icons/svg/pageIcons/airdropShipment.svg';
import IndexedDbWrapper from '../../core/wrappers/browserStorage/indexedDb-wrapper';
import { useHistory } from 'react-router-dom';
import SCUIDownloadButton from '../../atomic/atoms/SCUIDownloadButton/SCUIDownloadButton';
import { O } from './orders.classes';
import { buildOrdersFilterChips } from './ordersFilterChips.helper';

export const Orders = () => {
    let history = useHistory();
    const [loading, setLoading] = useState(false);
    const [cachedSearchedValues, setCachedSearchedValues] = useState<any>();
    const params = new URLSearchParams(window.location.search);

    const [orderInput, setOrderInput] = useState(initialState.filterInfo);
    const [orderForDrawerContent, setOrderForDrawerContent] = useState<any>();
    const { t } = useTranslation();
    const [datas, setDatas] = useState<any>();
    const onDrawerOpen = () => setDrawerOpen(true);
    const onDrawerClose = () => setDrawerOpen(false);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const onDrawerFilterOpen = () => setDrawerFilterOpen(true);
    const onDrawerFilterClose = () => setDrawerFilterOpen(false);
    const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
    const [orderStatusList, setOrderStatusList] = useState<any[]>([]);
    const [paymentMethodList, setPaymentMethodList] = useState([]);
    const [cargoNameList, setCargoNameList] = useState([]);
    const [pageSize, setPageSize] = useState(10);
    const [pageNumber, setPageNumber] = useState(0);
    const [rowCount, setRowCount] = useState(0);
    const [refresh, setRefresh] = useState(false);
    const [firstRender, setFirstRender] = useState(true);
    const [canCreateRefund, setCanCreateRefund] = useState<boolean>(true);
    const other_link: any = import.meta.env.VITE_APPURL!;

    useEffect(() => {
        GetCargoList();
        GetOrderStatusList();
        GetPaymentMethod();
    }, []);

    useEffect(() => {
        (async () => {
            const cachedOrders = await getRequests();
            if (cachedOrders.length <= 10) {
                setCachedSearchedValues(cachedOrders.reverse());
            } else {
                setCachedSearchedValues(cachedOrders.slice(Math.max(cachedOrders.length - 10, 1)).reverse());
            }
        })();
    }, []);
    useEffect(() => {
        //burda urlden aldığımız datyı filter parametresine çeviriyoruz
        const updatedState: Partial<OrderDetailFilter> = { ...orderInput };
        params.forEach((value, key) => {
            if (key in orderInput) {
                // Recognize 'key' as one of the keys from ReturnDetailFilter

                updatedState[key as keyof OrderDetailFilter] = value as any;
            }
        });
        if (params.get('take')) {
            setPageSize(Number(params.get('take')));
        }
        if (params.get('skip')) {
            setPageNumber(Number(params.get('skip')));
        }
        setOrderInput((prevState: any) => ({
            ...prevState,
            ...updatedState,
        }));
    }, [window.location.search]);

    useEffect(() => {
        if (JSON.stringify(orderInput) !== JSON.stringify(initialState.filterInfo)) {
            listele();
        }
    }, [orderInput]);

    useEffect(() => {
        if (!firstRender) listele();
    }, [pageNumber, pageSize]);
    const gotoCustomerOrder = (customerID: any) => {
        window.open(other_link + '/customerManagement?customerId=' + customerID, '_blank');
    };

    const columns: ExtendedGridColDef[] = [
        { field: 'shippingList', headerName: 'shippingList', flex: 1, hide: true },
        { field: 'id', headerName: 'id', flex: 1, hide: true },
        {
            field: 'customerId',
            headerName: t('customerInformation.customer'),
            width: 100,
            renderCell: (params) => {
                return (
                    <div className={O.cellCustomerWrap}>
                        <Button
                            className={O.cellCustomerButton}
                            onClick={() => gotoCustomerOrder(params.row.customerId)}
                        >
                            <p>
                                {' '}
                                {params.row.firstName && params.row.firstName.trim().length > 0
                                    ? params.row.firstName + ' ' + params.row.lastName
                                    : params.row.customerId}
                            </p>
                        </Button>
                    </div>
                );
            },
        },
        {
            field: 'eMail',
            minWidth: 100,
            headerName: t('general.eMail'),
            flex: 1,
            renderCell: (params: any) => {
                return (
                    <div className={O.cellEmailWrap}>
                        <Tooltip title={<h1>{params.row.eMail}</h1>}>
                            <Button
                                className={O.cellEmailButton}
                                onClick={() => gotoCustomerOrder(params.row.customerId)}
                            >
                                <p> {params.row.eMail}</p>
                            </Button>
                        </Tooltip>
                    </div>
                );
            },
        },
        {
            field: 'orderNumber',
            minWidth: 100,
            headerName: t('general.orderNo'),
            flex: 1,
            renderCell: (params: any) => {
                return (
                    <div className={O.cellOrderNumberWrap}>
                        <Tooltip title={<h1>{params.row.orderNumber}</h1>}>
                            <Link
                                className={O.cellOrderNumberLink}
                                style={{ fontSize: '11px' }}
                                target={'_blank'}
                                href={`/orderDetail?orderNumber=${params.row.orderNumber}`}
                            >
                                {params.row.orderNumber}
                            </Link>
                        </Tooltip>
                    </div>
                );
            },
        },
        {
            field: 'orderStatusName',
            minWidth: 120,
            headerName: t('customerInformation.status'),
            flex: 1,
            hide: false,
            renderCell: (params) => {
                return (
                    <div className={O.cellOrderStatusWrap}>
                        <p> {params.row.orderStatusName} </p>
                    </div>
                );
            },
        },
        {
            field: 'shippingListNo',
            minWidth: 100,
            headerName: t('general.shippingNo'),
            flex: 1,
            renderCell: (params: any) => {
                return (
                    <div className={O.cellShippingListNoWrap}>
                        <Tooltip title={<h1>{params.row.shippingListNo}</h1>}>
                            <p>{params.row.shippingListNo}</p>
                        </Tooltip>
                    </div>
                );
            },
        },
        {
            field: 'shippingStatusName',
            minWidth: 120,
            headerName: t('order.shippingInformation'),
            flex: 1,
        },
        {
            field: 'grandTotal',
            minWidth: 100,
            headerName: t('general.cost'),
            width: 100,
        },
        {
            field: 'paymentMethodName',
            minWidth: 100,
            headerName: t('general.paymentMethod'),
            renderCell: (params) => {
                return (
                    <Tooltip title={<h1>{params.row.paymentMethodName}</h1>}>
                        <div className={O.cellPaymentMethodWrap}>{params.row.paymentMethodName}</div>
                    </Tooltip>
                );
            },
        },
        {
            field: 'storeCode',
            minWidth: 100,
            headerName: t('general.storeCode'),
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                return (
                    <Tooltip title={<h1>{params.row.storeCode}</h1>}>
                        <div className={O.cellStoreCodeWrap}>{params.row.storeCode ?? '-'}</div>
                    </Tooltip>
                );
            },
        },
        {
            field: 'orderDate',
            minWidth: 110,
            headerName: t('general.orderDate'),
            flex: 1,
            renderCell: (params) => {
                return <div className={O.cellOrderDateWrap}>{TimeHelper.formatDateHour(params.row.orderDate)}</div>;
            },
        },
        { field: 'platformName', headerName: 'Platform', width: 70 },
        {
            field: 'shippingCompanyName',
            headerName: t('general.cargoCompany'),
            flex: 1,
        },
        {
            field: 'deneme ',
            headerName: ' ',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            renderCell: (params) => {
                const handleClick = (popupState: any, tur: string) => {
                    popupState.close();
                    switch (tur) {
                        case 'showDetail': {
                            setOrderForDrawerContent(params.row);
                            onDrawerOpen();
                            break;
                        }
                        case 'gotoDetail': {
                            window.open(other_link + '/orderDetail?orderNumber=' + params.row.orderNumber, '_blank');
                            break;
                        }
                        case 'return': {
                            window.open(other_link + '/createReturn/?orderNumber=' + params.row.orderNumber, '_blank');
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                };
                return (
                    <PopupState variant="popover" popupId="demo-popup-menu">
                        {(popupState: any) => (
                            <>
                                <IconButton className={O.cellActionsButton} {...bindTrigger(popupState)}>
                                    {' '}
                                    <MoreVertIcon className="svg_icons" />{' '}
                                </IconButton>
                                <Menu
                                    {...bindMenu(popupState)}
                                    slotProps={{ paper: { className: O.cellActionsMenu } }}
                                >
                                    {canCreateRefund && (
                                        <MenuItem
                                            className={O.cellActionsMenuItemReturn}
                                            onClick={() => handleClick(popupState, 'return')}
                                        >
                                            {t('refund.createReturn')}{' '}
                                        </MenuItem>
                                    )}
                                    <MenuItem
                                        className={O.cellActionsMenuItemDetail}
                                        onClick={() => handleClick(popupState, 'gotoDetail')}
                                    >
                                        {t('general.goToDetail')}{' '}
                                    </MenuItem>
                                    <MenuItem
                                        className={O.cellActionsMenuItemQuickView}
                                        onClick={() => handleClick(popupState, 'showDetail')}
                                    >
                                        {t('general.quickView')}
                                    </MenuItem>
                                </Menu>
                            </>
                        )}
                    </PopupState>
                );
            },
        },
    ];
    const listele = async () => {
        setFirstRender(false);
        setLoading(true);
        const newUrl = '/orders?' + Helper.buildURLFromObject(orderInput);
        history.push(newUrl);

        let params = {
            ...orderInput,

            Barcodes: Array.isArray(orderInput.Barcodes)
                ? orderInput.Barcodes
                : typeof orderInput.Barcodes === 'string' && orderInput.Barcodes
                  ? orderInput.Barcodes.split(',')
                  : [],

            orderStatusIds: Array.isArray(orderInput.orderStatusIds)
                ? orderInput.orderStatusIds
                : typeof orderInput.orderStatusIds === 'string' && orderInput.orderStatusIds
                  ? orderInput.orderStatusIds.split(',')
                  : [],
        };

        OrderCommand.PostGetOrder(params)
            .then((res: any) => {
                if (res) {
                    let parseData = res.formattedServiceResult.map((item: any) => {
                        return {
                            customerId: item.customerId || '-',
                            eMail: item.email || '-',
                            orderNumber: item.orderNumber || '-',
                            orderStatusName: item.orderStatusName || '-',
                            shippingListNo: item.shippingListNo || '-',
                            shippingStatusName: item.shippingStatusName || '-',
                            grandTotal: item.grandTotal || '-',
                            paymentMethodName: item.paymentMethodName || '-',
                            storeCode: item.storeCode || '-',
                            lastStatusUpdateDate: item.lastStatusUpdateDate || '-',
                            platformName: item.platformName,
                            shippingCompanyName: item.shippingCompanyName || '-',
                            orderId: item.orderId || '-',
                            sellerName: item.sellerName || '-',
                            orderDate: item.orderDate || '-',
                            firstName: item.firstName,
                            lastName: item.lastName,
                            dPackageCargoShipmentCode: item.dPackageCargoShipmentCode || '-',
                            trackingCode: item.trackingCode || '-',
                        };
                    });
                    setCanCreateRefund(res.canStoreUserCreateRefund);
                    setDatas(parseData);
                    setRowCount(res.count);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const GetCargoList = async () => {
        try {
            let cargoList: any = await CargoQuery.CompanyList();
            setCargoNameList(cargoList.data && [...[{ id: '0', name: t('general.all') }], ...cargoList.data]);
        } catch (error) {
            console.log('Hata :>> ', error);
        }
    };
    const GetOrderStatusList = async () => {
        try {
            let orderStatusList: any = await OrderQuery.GetOrderStatusList();
            setOrderStatusList(
                orderStatusList.data && [
                    ...[{ orderStatusId: '-1', backendDescriptionKey: t('general.all') }],
                    ...orderStatusList.data,
                ]
            );
        } catch (error) {
            console.log('Hata :>> ', error);
        }
    };
    const GetPaymentMethod = async () => {
        try {
            const requestData = {
                Context: {
                    IsOperator: true,
                },
            };
            let paymentMethodList: any = await PaymentCommand.GetPaymentMethodList(requestData);
            setPaymentMethodList(
                paymentMethodList.data.paymentMethodContracts && [
                    ...[{ paymentMethodId: '0', paymentMethodName: t('general.all') }],
                    ...paymentMethodList.data.paymentMethodContracts,
                ]
            );
        } catch (error) {
            console.log('Hata :>> ', error);
        }
    };
    const handleClear = async () => {
        const cachedOrders = await getRequests();
        for (const searchList of cachedOrders) {
            await IndexedDbWrapper.deleteItemFromDb('orderRequests', searchList.id);
        }
        setCachedSearchedValues([]);
        setRefresh((prev) => !prev);
    };
    useEffect(() => {
        (async () => {
            const cachedOrders = await getRequests();
            if (cachedOrders.length <= 10) {
                setCachedSearchedValues(cachedOrders.reverse());
            } else {
                setCachedSearchedValues(cachedOrders.slice(Math.max(cachedOrders.length - 10, 1)).reverse());
            }
        })();
    }, [refresh]);
    function deleteRequests(id: number) {
        IndexedDbWrapper.deleteItemFromDb('orderRequests', id);
        getRequests();
        setRefresh((prevLoading: boolean) => !prevLoading);
    }

    const showLastSearched = () => {
        setDatas(null);
        setRefresh((prev) => !prev);
    };
    const CHIP_COLORS = [
        { bg: 'rgba(25,118,210,0.07)', border: 'rgba(25,118,210,0.28)', icon: '#1976d2' },
        { bg: 'rgba(0,150,136,0.07)', border: 'rgba(0,150,136,0.28)', icon: '#00897b' },
        { bg: 'rgba(103,58,183,0.07)', border: 'rgba(103,58,183,0.28)', icon: '#7b1fa2' },
        { bg: 'rgba(230,81,0,0.07)', border: 'rgba(230,81,0,0.28)', icon: '#e65100' },
        { bg: 'rgba(48,63,159,0.07)', border: 'rgba(48,63,159,0.28)', icon: '#283593' },
        { bg: 'rgba(27,94,32,0.07)', border: 'rgba(27,94,32,0.28)', icon: '#2e7d32' },
        { bg: 'rgba(0,131,143,0.07)', border: 'rgba(0,131,143,0.28)', icon: '#00838f' },
        { bg: 'rgba(173,20,87,0.07)', border: 'rgba(173,20,87,0.28)', icon: '#ad1457' },
        { bg: 'rgba(191,54,12,0.07)', border: 'rgba(191,54,12,0.28)', icon: '#bf360c' },
        { bg: 'rgba(78,52,46,0.07)', border: 'rgba(78,52,46,0.28)', icon: '#4e342e' },
    ];

    const buildFilterChips = (request: any) => buildOrdersFilterChips(request, t, orderStatusList);

    const excelOrders =
        (datas &&
            datas?.map((order: any) => ({
                customerId: order.customerId,
                eMail: order.eMail,
                orderNumber: order.orderNumber,
                orderStatusName: order.orderStatusName,
                shippingListNo: order.shippingListNo,
                shippingStatusName: order.shippingStatusName,
                grandTotal: order.grandTotal,
                paymentMethodName: order.paymentMethodName,
                storeCode: order.storeCode,
                orderDate: order?.orderDate ? TimeHelper.formatDateHour(order.orderDate) : '',
                platformName: order.platformName,
                shippingCompanyName: order.shippingCompanyName,
                lastStatusUpdateDate: order?.lastStatusUpdateDate
                    ? TimeHelper.formatDateHour(order.lastStatusUpdateDate)
                    : '',
                shippingList: order.shippingList,
                firstName: order.firstName,
                lastName: order.lastName,
                sellerName: order.sellerName,
                orderId: order.orderId,
                orderDateStr: order?.orderDate ? TimeHelper.formatDateHour(order.orderDate) : '',
                dPackageNo: order.dPackageCargoShipmentCode || '-',
                mpCargoShipmentNo: order.trackingCode || '-',
            }))) ||
        [];
    return (
        <SCUIContent className={O.page}>
            <SCUIGeneralDrawer
                open={drawerOpen}
                anchor="right"
                width={'450px'}
                paperClassName={O.detailDrawerPaper}
                onClose={(event: any, reason: any) => {
                    if (reason === 'backdropClick') {
                        setDrawerOpen(false);
                    }
                }}
            >
                <SCUIOrderDetailDrawerContent detail={orderForDrawerContent} onClose={onDrawerClose} />
            </SCUIGeneralDrawer>
            <SCUIGeneralDrawer
                open={drawerFilterOpen}
                width={'360px'}
                paperClassName={O.filterDrawerPaper}
                onClose={(event: any, reason: any) => {
                    if (reason === 'backdropClick') {
                        setDrawerFilterOpen(false);
                    }
                }}
            >
                <SCUIOrderFilter
                    cargoNameList={cargoNameList}
                    orderStatusList={orderStatusList}
                    orderInput={orderInput}
                    paymentList={paymentMethodList}
                    setOrderInput={setOrderInput}
                    onClose={onDrawerFilterClose}
                    setCachedSearchedValues={setCachedSearchedValues}
                />
            </SCUIGeneralDrawer>
            <Grid className={O.breadcrumbSection} container direction="row" spacing={2}>
                <SCUIBreadCrumb
                    title={t('dashboard.order')}
                    componentLink={'/orders'}
                    onClick={() => {
                        setOrderInput(initialState.filterInfo);
                        setDatas(null);
                    }}
                />
            </Grid>
            <div className={O.loadingSection}>
                <SCUILoadingLinear display={loading} />
            </div>
            {datas ? (
                <Grid
                    className={O.resultsLayout}
                    sx={{ marginTop: '16px' }}
                    container
                    direction="row"
                    justifyContent="flex-end"
                >
                    <Grid className={O.lastSearchedButtonWrap} sx={{ marginRight: '8px' }}>
                        <Tooltip title={t('order.lastSearched')}>
                            <IconButton
                                className={O.lastSearchedIconButton}
                                sx={{
                                    width: 34,
                                    height: 34,
                                    borderRadius: 2,
                                    border: '1px solid',
                                    borderColor: 'primary.main',
                                }}
                                onClick={showLastSearched}
                            >
                                <HistoryIcon className="svg_icons" sx={{ color: 'primary.main' }} />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                    <Grid className={O.openFilterButtonWrap}>
                        <IconButton
                            className={O.openFilterIconButton}
                            sx={{
                                width: 34,
                                height: 34,
                                borderRadius: 2,
                                border: '1px solid',
                                borderColor: 'primary.main',
                            }}
                            onClick={() => onDrawerFilterOpen()}
                        >
                            <SearchIcon className="svg_icons" sx={{ color: 'primary.main' }} />
                        </IconButton>
                    </Grid>
                    {datas && (
                        <Grid className={O.excelDownloadWrap}>
                            <SCUIDownloadButton
                                position="right"
                                containerStyle={{ marginLeft: '16px', height: '40px' }}
                                excelData={{
                                    excelDownloadData: excelOrders,
                                    excelDownloadFolderName: t('order.title'),
                                    excelDownloadButtonText: t('order.exportOrders'),
                                    hiddenExcelColumn: [
                                        'id',
                                        'shippingList',
                                        'firstName',
                                        'lastName',
                                        'sellerName',
                                        'orderId',
                                        'orderDateStr',
                                        'lastStatusUpdateDate',
                                    ],
                                    //logo: excelLogo || undefined,
                                }}
                            />
                        </Grid>
                    )}
                    <Grid
                        className={O.dataGridWrap}
                        size={{
                            sm: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <SCUICustomDataGrid
                            onPageSizeChange={(i: number) => {
                                setOrderInput({ ...orderInput, take: Number(i), skip: 0 });
                                setPageSize(i);
                                setPageNumber(0);
                            }}
                            pageSize={pageSize}
                            paginationModeChange
                            onPageChange={(i: number) => {
                                setPageNumber(i);
                                setOrderInput({ ...orderInput, skip: Number(i) });
                            }}
                            page={pageNumber}
                            randomId
                            rows={datas}
                            columns={columns}
                            rowCount={rowCount}
                        />
                    </Grid>
                </Grid>
            ) : (
                <Box className={O.recentSearchesSection} sx={{ mt: 3 }}>
                    {!loading && cachedSearchedValues && cachedSearchedValues.length > 0 ? (
                        <>
                            <Box
                                className={O.recentSearchesHeader}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    mb: 3,
                                    pb: 2,
                                    borderBottom: '2px solid',
                                    borderColor: 'divider',
                                }}
                            >
                                <Box
                                    className={O.recentSearchesTitleGroup}
                                    sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}
                                >
                                    <HistoryIcon sx={{ color: 'text.primary', fontSize: 22 }} />
                                    <Typography
                                        className={O.recentSearchesTitle}
                                        variant="h6"
                                        fontWeight={800}
                                        color="text.primary"
                                        fontSize={16}
                                        letterSpacing={0.2}
                                    >
                                        {t('general.recentlySearched')}
                                    </Typography>
                                    <Chip
                                        className={O.recentSearchesCountChip}
                                        label={cachedSearchedValues.length}
                                        size="small"
                                        sx={{
                                            height: 22,
                                            fontSize: 12,
                                            fontWeight: 800,
                                            backgroundColor: 'grey.200',
                                            color: 'text.primary',
                                        }}
                                    />
                                </Box>
                                <Box className={O.recentSearchesActions} sx={{ display: 'flex', gap: 1 }}>
                                    <SCUIButton
                                        className={O.recentSearchesSearchButton}
                                        style={{ height: '34px', padding: '0 16px' }}
                                        text={t('general.search')}
                                        type="primary"
                                        sizeType="fixed"
                                        size={'s'}
                                        showStartIcon
                                        startIcon={<SearchIcon style={{ fontSize: '15px' }} />}
                                        onClick={() => onDrawerFilterOpen()}
                                    />
                                    <SCUIButton
                                        className={O.recentSearchesClearButton}
                                        style={{ height: '34px', padding: '0 16px' }}
                                        text={t('general.clearList')}
                                        type="secondary"
                                        sizeType="fixed"
                                        size={'s'}
                                        showStartIcon
                                        startIcon={<DeleteIcon style={{ fontSize: '15px' }} />}
                                        onClick={() => handleClear()}
                                    />
                                </Box>
                            </Box>

                            <Stack className={O.recentSearchesList} spacing={1.5}>
                                {cachedSearchedValues.map((cachedVal: any, idx: number) => {
                                    const chips = buildFilterChips(cachedVal.request);
                                    return (
                                        <Card
                                            className={O.recentSearchCard}
                                            key={cachedVal.id}
                                            elevation={0}
                                            onClick={() => setOrderInput(cachedVal.request)}
                                            sx={{
                                                border: '1px solid',
                                                borderColor: 'grey.200',
                                                borderLeft: '4px solid',
                                                borderLeftColor: 'grey.400',
                                                borderRadius: 2.5,
                                                cursor: 'pointer',
                                                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                                                '&:hover': {
                                                    borderColor: 'grey.300',
                                                    borderLeftColor: 'primary.main',
                                                    boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
                                                    transform: 'translateY(-1px)',
                                                    backgroundColor: 'grey.50',
                                                },
                                            }}
                                        >
                                            <CardContent
                                                className={O.recentSearchCardContent}
                                                sx={{ py: 2, px: 2.5, '&:last-child': { pb: 2 } }}
                                            >
                                                <Box
                                                    className={O.recentSearchCardLayout}
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'flex-start',
                                                        justifyContent: 'space-between',
                                                        gap: 2,
                                                    }}
                                                >
                                                    <Box className={O.recentSearchCardBody} sx={{ flex: 1, minWidth: 0 }}>
                                                        <Box
                                                            className={O.recentSearchCardMeta}
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: 1,
                                                                mb: 1.5,
                                                            }}
                                                        >
                                                            <HistoryIcon sx={{ fontSize: 14, color: 'grey.500' }} />
                                                            <Typography
                                                                className={O.recentSearchCardDate}
                                                                variant="caption"
                                                                color="text.secondary"
                                                                fontWeight={700}
                                                                fontSize={12}
                                                            >
                                                                {TimeHelper.formatDateHour(cachedVal.insert_date)}
                                                            </Typography>
                                                            <Chip
                                                                className={O.recentSearchCardIndexChip}
                                                                label={`#${cachedSearchedValues.length - idx}`}
                                                                size="small"
                                                                sx={{
                                                                    height: 20,
                                                                    fontSize: 10,
                                                                    borderRadius: 1,
                                                                    fontWeight: 800,
                                                                    backgroundColor: 'grey.100',
                                                                    color: 'text.secondary',
                                                                }}
                                                            />
                                                        </Box>
                                                        {chips.length > 0 ? (
                                                            <Box
                                                                className={O.recentSearchCardChips}
                                                                sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}
                                                            >
                                                                {chips.map((chip, chipIdx) => {
                                                                    const c =
                                                                        CHIP_COLORS[chip.colorKey % CHIP_COLORS.length];
                                                                    return (
                                                                        <Chip
                                                                            className={O.recentSearchCardChip}
                                                                            key={chipIdx}
                                                                            icon={chip.icon}
                                                                            label={
                                                                                <span>
                                                                                    <strong>{chip.tooltip}:</strong>{' '}
                                                                                    {chip.value}
                                                                                </span>
                                                                            }
                                                                            size="medium"
                                                                            sx={{
                                                                                fontSize: 12,
                                                                                height: 32,
                                                                                fontWeight: 500,
                                                                                backgroundColor: c.bg,
                                                                                color: 'text.primary',
                                                                                border: '1px solid',
                                                                                borderColor: c.border,
                                                                                '& .MuiChip-icon': {
                                                                                    fontSize: 16,
                                                                                    color: c.icon,
                                                                                },
                                                                                '& .MuiChip-label': { px: 1.5 },
                                                                            }}
                                                                        />
                                                                    );
                                                                })}
                                                            </Box>
                                                        ) : (
                                                            <Typography
                                                                className={O.recentSearchCardEmpty}
                                                                variant="caption"
                                                                color="text.disabled"
                                                                fontStyle="italic"
                                                            >
                                                                —
                                                            </Typography>
                                                        )}
                                                    </Box>

                                                    <Box
                                                        className={O.recentSearchCardActions}
                                                        sx={{ display: 'flex', flexShrink: 0, alignItems: 'center' }}
                                                    >
                                                        <Tooltip title={t('general.delete')} placement="top">
                                                            <IconButton
                                                                className={O.recentSearchDeleteButton}
                                                                size="small"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    deleteRequests(cachedVal.id);
                                                                }}
                                                                sx={{
                                                                    width: 34,
                                                                    height: 34,
                                                                    color: 'grey.400',
                                                                    borderRadius: 1.5,
                                                                    transition: 'all 0.2s ease',
                                                                    '&:hover': {
                                                                        backgroundColor: 'error.50',
                                                                        color: 'error.main',
                                                                    },
                                                                }}
                                                            >
                                                                <DeleteIcon sx={{ fontSize: 18 }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Box>
                                                </Box>
                                            </CardContent>
                                        </Card>
                                    );
                                })}
                            </Stack>
                        </>
                    ) : (
                        <Box
                            className={O.emptyState}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <SCUINoRecordComponent img={airdropShipment} />
                            <Grid className={O.emptyStateOpenFilterWrap}>
                                <IconButton
                                    className={O.emptyStateOpenFilterIconButton}
                                    sx={{
                                        width: 48,
                                        height: 48,
                                        marginTop: '16px',
                                        borderRadius: 2,
                                        border: '1px solid',
                                        borderColor: 'primary.main',
                                    }}
                                    onClick={() => onDrawerFilterOpen()}
                                >
                                    <SearchIcon className="svg_icons" sx={{ color: 'primary.main' }} />
                                </IconButton>
                            </Grid>
                        </Box>
                    )}
                </Box>
            )}
        </SCUIContent>
    );
};
